import {useListView} from '../../core/ListViewProvider'
import {PartysListToolbar} from './PartyListToolbar'
import {PartysListGrouping} from './PartiesListGrouping'
import {PartysListSearchComponent} from './PartiesListSearchComponent'
import { useNavigate } from 'react-router-dom';
import { KTSVG } from 'src/_metronic/helpers';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Dispatch, SetStateAction } from 'react';

interface PartiesListHeaderProps {
  showParty: boolean;
  setShowParty: Dispatch<SetStateAction<boolean>>;
}

const PartysListHeader: React.FC<PartiesListHeaderProps> = ({ showParty, setShowParty }) => {
  const {selected} = useListView()
  const navigate = useNavigate();

  const handleToggleBalance = () => {
    setShowParty((prev) => !prev); // Toggle state
    // Optional: Add logic to update context, Redux, or API if needed
    // Example: dispatch({ type: 'TOGGLE_BALANCE', payload: !showParty });
  };

  return (
    <>
    <div className='card-header border-0 pt-6'>
      <h2 className='mt-5 pt-1'>Manage Party</h2>

      <PartysListSearchComponent />

      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <PartysListGrouping /> : <PartysListToolbar showParty={showParty} setShowParty={setShowParty}/>}
        {/* end::Group actions */}
         
        {/* <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
      <button onClick={() => navigate(-1)} className="btn btn-secondary">
        ← Back
      </button>
    </div> */}

    {/* <div
        className='btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary bg-white h-30px w-30px position-absolute start-100 translate-middle'
        style={{zIndex: 99, top: '53px',marginLeft: '-26px'}}

        onClick={() => navigate(-1)}
      >
        <KTSVG path='/media/icons/duotune/arrows/arr025.svg' className='svg-icon-2' />
      </div> */}
      </div>
      {/* end::Card toolbar */}
      {/* <button onClick={() => navigate(-1)} className='btn btn-secondary'>
      ←
    </button> */}
      {/* <div
                className='btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary bg-white h-30px w-30px position-absolute start-100 translate-middle'
                style={{zIndex: 99, top: '52px',marginLeft: '-20px'}}
        
                onClick={() => navigate(-1)}
              >
                <KTSVG path='/media/icons/duotune/arrows/arr025.svg' className='svg-icon-2' />
              </div> */}
              {/* <div
        className="btn btn-icon btn-shadow-lg  bg-primary text-white position-absolute start-100 translate-middle d-flex align-items-center justify-content-center border border-light"
        style={{ zIndex: 99, top: "52px", marginLeft: "-20px" ,width: "34px",
          height: "32px"}}
        role="button"
        aria-label="Go back to previous page"
        tabIndex={0}
        data-tooltip="Back"
        onClick={() => navigate(-1)}
      >
        <KTSVG path="/media/icons/duotune/arrows/arr025.svg" className="svg-icon-4 text-white" />
      </div> */}
    </div>
    </>
  )
}

export {PartysListHeader}
